import { APP_BASENAME } from "@/config";

export const BASE_CDN_URL = `${location.origin}${APP_BASENAME}/`;
